import { Component } from '@angular/core';

@Component({
  selector: 'volume-icon',
  standalone: true,
  imports: [],
  templateUrl: './volume.component.html',
  styleUrl: './volume.component.scss'
})
export class VolumeIcon {

}
